import { Trans } from "@lingui/react/macro";
import { useEffect, useState } from "react";

import type { AppModel } from "../../../app/app-model";

import { EmailLogin } from "./email-login";
import { PasswordLogin } from "./password-login";

type LoginView = "password" | "email";

export function LoginRoute(props: { app: AppModel }) {
  const [view, setView] = useState<LoginView>("password");

  useEffect(() => {
    void props.app.seerlinqApi.hasSession().then((hasSession) => {
      if (hasSession) {
        window.location.href = "/";
      }
    });
  }, [props.app.seerlinqApi]);

  return (
    <div className="grow flex items-center justify-center">
      <div className="flex flex-col w-80">
        <h2 className="text-xl font-semibold mb-11">
          <Trans>Log in</Trans>
        </h2>

        {view === "password" && (
          <PasswordLogin
            app={props.app}
            onEmailLogin={() => setView("email")}
          />
        )}
        {view === "email" && <EmailLogin onBack={() => setView("password")} />}
      </div>
    </div>
  );
}
